var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "column",
      class: [
        _vm.$.column,
        "board_column",
        _vm.taskDragging && _vm.$.task_drag_active,
        _vm.isCollapsed && _vm.$.collapsed,
        _vm.taskSettingsInfo && _vm.$.task_settings_opened,
        _vm.isCollapsed && "column_drag_handle",
      ],
      on: { click: _vm.columnClickHandler },
    },
    [
      _c(
        "div",
        { class: [_vm.$.header, !_vm.isCollapsed && "column_drag_handle"] },
        [
          _c("div", { class: _vm.$.info }, [
            _c(
              "div",
              { class: _vm.$.main },
              [
                _vm.column.picture
                  ? _c("vgp-avatar", {
                      class: _vm.$.avatar,
                      attrs: { src: _vm.column.picture, size: "small" },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.column.id === "empty" &&
                _vm.groupingFieldInfo.key === "resources" &&
                !_vm.groupingFieldInfo.isCustom
                  ? _c("svg-sprite", {
                      style: { minWidth: "24px" },
                      attrs: {
                        type: "regular",
                        size: 24,
                        name: "assigned",
                        color: "#333333",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: [
                      _vm.$.label,
                      _vm.column.headerColor && _vm.$.colored,
                    ],
                    style: {
                      backgroundColor: _vm.column.headerColor,
                    },
                  },
                  [
                    !_vm.column.noLabel
                      ? _c(
                          "span",
                          {
                            style: {
                              color: _vm.column.headerLabelColor || "",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.column.value.toUpperCase()) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { class: _vm.$.counter }, [
              _vm._v("\n        " + _vm._s(_vm.allTasks.length) + "\n      "),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.$.buttons },
            [
              _vm.showCollapse
                ? _c("iconButton", {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          content: _vm.isCollapsed
                            ? _vm.locale("board_column_expand")
                            : _vm.locale("board_column_collapse"),
                          duration: [300, 0],
                          delay: [200, 0],
                        },
                        expression:
                          "{ content: isCollapsed ? locale('board_column_expand') : locale('board_column_collapse'), duration: [300, 0], delay: [200, 0] }",
                      },
                    ],
                    attrs: {
                      icon: {
                        name: _vm.isCollapsed ? "expand-4" : "collaps-2",
                        type: "regular",
                        size: 20,
                      },
                    },
                    on: { onClick: _vm.collapseToggle },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("iconButton", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showCreate,
                    expression: "showCreate",
                  },
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      content: _vm.locale("board_task_create"),
                      duration: [300, 0],
                      delay: [200, 0],
                    },
                    expression:
                      "{ content: locale('board_task_create'), duration: [300, 0], delay: [200, 0] }",
                  },
                ],
                attrs: { icon: { name: "plus-1", type: "regular", size: 20 } },
                on: { onClick: _vm.newTask },
              }),
              _vm._v(" "),
              _vm.showMore
                ? _c("iconButton", {
                    attrs: {
                      icon: { name: "more-1", type: "regular", size: 20 },
                    },
                    on: {
                      onClick: function (e) {
                        return _vm.toggleContextMenu(
                          _vm.column,
                          "column",
                          "main",
                          e.target
                        )
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "cardsScrollWrapper",
          class: [
            _vm.$.column_content,
            "gantt_scroll",
            _vm.showColumnShadow ? _vm.$.shadowScroll : null,
          ],
        },
        [
          _c(
            "draggable",
            _vm._b(
              {
                ref: "cardsDndContainer",
                class: [
                  "cards_dnd_container",
                  _vm.$.cards,
                  _vm.isCollapsed ? _vm.$.collapsed_column : "",
                  _vm.taskDragging ? _vm.$.drag_accept : "",
                ],
                style: {
                  paddingTop: _vm.paddingTop + "px",
                  paddingBottom: _vm.paddingBottom + "px",
                },
                attrs: {
                  group: {
                    name: "cards",
                    put: _vm.canDragTasks ? ["cards"] : false,
                  },
                  value: _vm.visibleTasks,
                  "data-column-id": _vm.column.id,
                  move: _vm.onTaskMove,
                },
                on: { start: _vm.onTaskDragStart, end: _vm.onTaskDrop },
              },
              "draggable",
              {
                animation: 200,
                group: "cards",
                disabled: _vm.taskCardEditing || _vm.taskSettingsInfo,
                draggable: "." + _vm.$.card_wrapper,
                ghostClass: _vm.$.drop_preview,
                forceFallback: true,
                fallbackClass: "card_drag",
                fallbackOnBody: true,
                fallbackTolerance: 5,
                easing: "cubic-bezier(1, 0, 0, 1)",
                dataIdAttr: "data-id",
                emptyInsertThreshold: 0,
                scrollSensitivity: 200,
                scrollSpeed: 25,
              },
              false
            ),
            [
              _vm._l(_vm.visibleTasks, function (task) {
                return _c(
                  "div",
                  {
                    key: _vm.column.id + ":" + task.id,
                    class: _vm.$.card_wrapper,
                    attrs: { "data-id": task.id },
                  },
                  [
                    _vm.tasksMap[task.id]
                      ? _c("card", {
                          attrs: {
                            "column-id": _vm.column.id,
                            task: _vm.tasksMap[task.id],
                            projectResources: _vm.projectResources,
                          },
                          on: {
                            taskChange: function (e) {
                              return _vm.$emit("taskChange", e)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm._l(_vm.draftTasks, function (draftTask) {
                return [
                  draftTask.columnId === _vm.column.id
                    ? _c(
                        "div",
                        {
                          key: _vm.column.id + ":" + draftTask.id,
                          class: _vm.$.new_card_wrapper,
                        },
                        [
                          _c("card", {
                            attrs: {
                              "column-id": _vm.column.id,
                              task: draftTask,
                              projectResources: _vm.projectResources,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.$.bottom_part, on: { mouseover: _vm.mouseOver } },
            [
              _vm.emptyTask
                ? _c(
                    "div",
                    {
                      key: _vm.column.id + ":create",
                      ref: "newCardWrapper",
                      class: _vm.$.new_card_wrapper,
                    },
                    [
                      _c("card", {
                        attrs: {
                          "column-id": _vm.column.id,
                          task: { id: "create" },
                        },
                        on: { createTask: _vm.createTask },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("iconButton", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showCreate,
                    expression: "showCreate",
                  },
                ],
                class: _vm.$.add_task_button,
                attrs: {
                  icon: { name: "plus-1", type: "regular", size: 20 },
                  label: _vm.locale("board_task_create"),
                  size: "middle",
                },
                on: { onClick: _vm.newTask },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }